module.exports = __webpack_public_path__ + "static/media/Паспорт GALAD Контур LED.fd201604.pdf";